// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/wake-turbulence-atc-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/wake-turbulence-atc-procedures/wake-turbulence-atc-procedures.js';

mount([g0]);
